import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// Penguin Random House — New-customers campaign (adc_ddkqja22n7). STOPPED on
// 2025-10-14. Real lifetime aggregates from ANALYTICS.ADS.CAMPAIGN_PERIODS
// (complete months Oct 2024 – Sep 2025).
export const campPrhNew: FaireAdCampaignEntity = {
  token: "camp_prh_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_penguin_rh",
  segment: "NEW_MARKETPLACE",
  status: "STOPPED",
  monthlyBudgetDollars: 500,
  startedRunningAt: "2024-10-17",
  stoppedRunningAt: "2025-10-14",
  segmentMetrics: {
    numCustomersAcquired: 130,
    salesDollars: 72258,
    totalAdsSpendDollars: 5639,
    cpaDollars: 43,
    bestEstimateSalesDollars: 72258,
    bestEstimateRoas: 12.81,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-07-20T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
